const errorMessages = {
  100: "HEADER_IS_MISSING",
  101: "DEVICE_TYPE_NOT_ALLOWED",
  104: "Invalid token",
  107: "User not found",
  111: "Invalid credentials",
  113: "Currently you account is inactive",
  115: "Enter correct old password",
  123: "Email sent failed",
  124: "Please enter valid code",
  125: "Code already used",
  129: "Daily email limit exceed",
  400: "BAD_REQUEST_PLEASE_CHECK_YOUR_INPUT",
  404: "RESOURCE_NOT_FOUND",
  500: "INTERNAL_SERVER_ERROR",
  200: "SUCCESS",
};

export const getErrorMessage = (code) => {
  return errorMessages[code] || "An unexpected error occurred.";
};
